var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{class:[
    'service-type-notification',
    {
      error: _vm.type === _vm.Types.ERROR,
      warn: _vm.type === _vm.Types.WARN,
    } ]},[_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }